import { render, staticRenderFns } from "./AmongRecords.vue?vue&type=template&id=33a5a94e&scoped=true&"
import script from "./AmongRecords.vue?vue&type=script&lang=js&"
export * from "./AmongRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a5a94e",
  null
  
)

export default component.exports